import { isBefore, startOfDay } from 'date-fns';
import {
  HabitSchedule,
  ScheduleEntry,
  ScheduleEntryState,
} from 'shared/types/habit-schedule';

export const getActualScheduleStartDate = (schedule: HabitSchedule) => {
  const firstEntry = schedule.entries?.reduce<ScheduleEntry | undefined>(
    (acc, entry) => {
      if (
        (entry.state === ScheduleEntryState.Complete && !!entry.value) ||
        entry.state !== ScheduleEntryState.Complete
      ) {
        return !acc || isBefore(entry.date, acc.date) ? entry : acc;
      }
      return acc;
    },
    undefined,
  );

  const firstPlannedOccurrenceDate = schedule.plannedOccurrences?.length
    ? new Date(
        Math.min(
          ...schedule.plannedOccurrences.map(({ date }) => date.getTime()),
        ),
      )
    : undefined;
  const scheduleStartDate = startOfDay(schedule.startDate);

  return new Date(
    Math.min(
      // get the schedule actual start date based on first entry, first plannedOccurrence and set startDate
      scheduleStartDate.getTime(),
      firstEntry
        ? startOfDay(firstEntry.date).getTime()
        : scheduleStartDate.getTime(),
      firstPlannedOccurrenceDate
        ? startOfDay(firstPlannedOccurrenceDate).getTime()
        : scheduleStartDate.getTime(),
    ),
  );
};

export const getActualSchedulesStartDate = (schedules: HabitSchedule[]) =>
  schedules.length
    ? getActualScheduleStartDate(
        schedules.toSorted(
          (scheduleA, scheduleB) =>
            scheduleA.startDate.getTime() - scheduleB.startDate.getTime(),
        )[0],
      )
    : undefined;
